import { Modal, Box, IconButton } from '@mui/material';

export const IframeModal = ({
  open,
  onClose,
  fileUrl,
}: {
  open: boolean;
  onClose: () => void;
  fileUrl: string;
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="iframe-modal"
      aria-describedby="iframe-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          height: '90%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
        }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ alignSelf: 'flex-end' }}>
          <p>close</p>
        </IconButton>
        <iframe
          title="pdf-viewer-iframe"
          src={
            import.meta.env.VITE_DEPLOYED_IN === 'LOCAL'
              ? `http://localhost:8001/csos2/assets/${fileUrl}`
              : import.meta.env.VITE_DOMAIN + `/assets/${fileUrl}`
          }
          width="95%"
          height="600"
          aria-label="sign in instructions"
          aria-describedby="signin-instruction"
        />
      </Box>
    </Modal>
  );
};
